export default (value: string) => {
  return /^([0-9])*$/.test(value);
};
